module.exports = __webpack_public_path__ + "img/组5253@2x.c4cd39ed.png";